/* eslint jsx-a11y/label-has-for: off */
/* eslint jsx-a11y/label-has-associated-control: off */
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import useIterateModifiers from '@/hooks/useIterateModifiers';

const ERROR_CLASS = 'dln-ratingStars--error';

const RatingStars = ({
  star,
  id,
  currValue,
  onChange,
  name,
  disabled,
  error,
  modifiers,
  indexRatingStar,
}) => {
  const stars = [];
  const modifiersString = useIterateModifiers('dln-ratingStars--', modifiers);

  [5, 4, 3, 2, 1].forEach(i => {
    const currId = `star--${id}-${indexRatingStar || star - i}`;
    stars.push(
      <Fragment key={currId}>
        <input
          id={currId}
          type='radio'
          name={name || id}
          value={i}
          defaultChecked={Math.round(currValue) === i}
          onChange={onChange}
          disabled={disabled}
        />
        <label className='dln-ratingStars__star' htmlFor={currId}>
          <i className='dln-icn dln-icn--iconfont' />
        </label>
      </Fragment>,
    );
  });

  return (
    <div
      className={`dln-ratingStars ${modifiersString} ${
        error ? ERROR_CLASS : ''
      }`}
      data-error={!!error}
    >
      {stars}
      <span className='dln-ratingStars__error'>{error}</span>
    </div>
  );
};

RatingStars.propTypes = {
  star: PropTypes.number,
  id: PropTypes.string.isRequired,
  currValue: PropTypes.number.isRequired,
  name: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  error: PropTypes.string,
  modifiers: PropTypes.arrayOf(PropTypes.string),
  indexRatingStar: PropTypes.number,
};

RatingStars.defaultProps = {
  star: 5,
  onChange: () => {},
  name: null,
  disabled: false,
  error: null,
  modifiers: [],
  indexRatingStar: null,
};

export default RatingStars;
